/* eslint-disable spire/export-styles */
import React, { FC } from "react";
import { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

const enum fields {
    background = "background",
    image = "image",
    backgroundColor = "backgroundColor",
    borderRadius = "borderRadius",
    backgroundSize = "backgroundSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.backgroundColor]: string;
        [fields.background]: "image" | "color";
        [fields.borderRadius]: string;
        [fields.backgroundSize]: "auto" | "cover" | "contain" | "100% 100%";
    };
}

type Props = OwnProps;

export interface BackgroundContainerStyles {
    container?: InjectableCss;
}

const styles: BackgroundContainerStyles = {};

export const staticPageContainerStyles = styles;

const BackgroundContainer: FC<Props> = ({ id, fields }) => {
    const backgroundStyles =
        fields.background === "image"
            ? `background-image: url(${fields.image}); background-size: ${fields.backgroundSize}`
            : `background-color: ${fields.backgroundColor};`;
    const borderShadowStyles = fields.borderRadius ? `border-radius: ${fields.borderRadius}px;` : `border-radius: 0px;`;
    const slideWrapperStyles = {
        css: css`
            padding: 35px 0;
            ${borderShadowStyles}
            ${backgroundStyles}
        `,
    };
    return (
        <StyledWrapper {...slideWrapperStyles}>
            <Zone contentId={id} zoneName="content" />
        </StyledWrapper>
    );
};

const backgroundContainer: WidgetModule = {
    component: BackgroundContainer,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
                fieldType: "General",
            },
            {
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                fieldType: "General",
            },
            {
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
                fieldType: "General",
            },
            {
                name: fields.borderRadius,
                editorTemplate: "TextField",
                displayName: "Border Radius",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.backgroundSize,
                displayName: "Background Size",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Auto", value: "auto" },
                    { displayName: "Cover", value: "cover" },
                    { displayName: "Contain", value: "contain" },
                    { displayName: "100% 100%", value: "100% 100%" },
                ],
                defaultValue: "auto",
                hideEmptyOption: true,
                fieldType: "General",
            },
        ],
    },
};

export default backgroundContainer;
